import { useEffect } from 'react';

export const usePreventPullToRefresh = (isActive: boolean, contentRef: React.RefObject<HTMLDivElement>) => {
    useEffect(() => {
        if (isActive) {
            document.body.style.overscrollBehavior = 'none';

            const handleTouchMove = (e: globalThis.TouchEvent) => {
                const drawerContent = contentRef.current;
                if (!drawerContent) return;

                if (
                    drawerContent.contains(e.target as Node) &&
                    drawerContent.scrollHeight > drawerContent.clientHeight
                ) {
                    const isAtTop = drawerContent.scrollTop === 0;
                    const isPullingDown = e.touches[0].pageY > e.touches[0].clientY;

                    if (isAtTop && isPullingDown) {
                        e.preventDefault();
                    }
                    return;
                }

                e.preventDefault();
            };

            document.addEventListener('touchmove', handleTouchMove, { passive: false });

            return () => {
                document.body.style.overscrollBehavior = 'auto';
                document.removeEventListener('touchmove', handleTouchMove);
            };
        }
    }, [isActive, contentRef]);
};
